import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import TableHeaderCell from '../../../../../newEditor/tablePart/tableHeaderCell';
import { TableHeaderRow } from '../../../../../newEditor/tablePart/styles';

function Header({
  activeCol, highlights, onToggleHighlight,
}) {
  return (
    <TableHeaderRow className="m-0 px-1 fs--1 d-flex">

      <Col xl={4} lg={4} className="px-0">
        <TableHeaderCell
          className="text-center text-xl-left"
          active={activeCol === 'channelMterial'}
          highlighted={highlights.includes('channelMterial')}
          onToggleHighlight={() => onToggleHighlight('channelMterial')}
        >
          Матеріал вентиляційного каналу
        </TableHeaderCell>
      </Col>

      <Col className="px-0">

        <TableHeaderCell
          className="text-center text-xl-left"
          active={activeCol === 'area'}
          highlighted={highlights.includes('area')}
          onToggleHighlight={() => onToggleHighlight('area')}
        >
          Площа перерізу вент. каналу
        </TableHeaderCell>
      </Col>

      <Col xl={2} lg={2} className="px-0">
        <TableHeaderCell
          className="text-center text-xl-left"
          active={activeCol === 'valueWind'}
          highlighted={highlights.includes('valueWind')}
          onToggleHighlight={() => onToggleHighlight('valueWind')}
        >
          Тяга у вент. каналі, Па
        </TableHeaderCell>
      </Col>

    </TableHeaderRow>
  );
}

Header.propTypes = {
  // fields: fieldsPropTypes.isRequired,
  activeCol: PropTypes.string,
  highlights: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggleHighlight: PropTypes.func.isRequired,
};

Header.defaultProps = {
  activeCol: null,
};

export default Header;
